import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";
import { PropsWithChildren, ReactNode } from "react";

type MobileBottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
};

export function MobileBottomSheet({
  isOpen,
  onClose,
  title,
  children,
}: PropsWithChildren<MobileBottomSheetProps>) {
  return (
    <>
      <button
        className={clsx(
          "fixed",
          "inset-0",
          "duration-200",
          "ease-in-out",
          "z-10",
          isOpen ? "opacity-20" : "opacity-0 pointer-events-none",
          "bg-black",
        )}
        onClick={onClose}
      />
      <div
        className={clsx(
          "fixed",
          "w-[100vw]",
          "h-[61.8vh]",
          "left-0",
          "overflow-auto",
          isOpen ? "bottom-0" : "-bottom-full",
          "duration-200",
          "z-10",
          "ease-in-out",
          "bg-canvas-primary",
          "rounded-t-3xl",
          "shadow-xl",
          "flex",
          "flex-col",
        )}
      >
        <div className="relative w-full flex flex-row items-center justify-between p-4">
          <div className="text-lg font-semibold">{title}</div>
          <button
            onClick={onClose}
            className={clsx(
              "rounded-full",
              "size-8",
              "bg-neutral",
              "flex",
              "justify-center",
              "items-center",
            )}
          >
            <FontAwesomeIcon
              icon={faXmark}
              className="text-font-secondary text-lg"
            />
          </button>
        </div>
        <div className="px-4 pb-4 flex-1">{children}</div>
      </div>
    </>
  );
}
